/* eslint-disable max-lines-per-function */
import { useState } from 'react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from '@/components/ui/command';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarStar,
  faPlusLarge,
} from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { CalendarSelectCommandItemValues } from '@/domain/termine/features/Calendar/shared/CalendarSelectCommandItemValues';
import { Link } from 'react-router-dom';

export function CalendarSelect() {
  const { t } = useTranslation();
  const { kalender, selectedKalenderIds, setSelectedKalenderIds } =
    useCalendarContext();
  const [localSelection, setLocalSelection] =
    useState<string[]>(selectedKalenderIds);

  function handleOpenChange() {
    setLocalSelection(selectedKalenderIds);
  }

  function handleSelect(kalenderId: string) {
    if (localSelection.includes(kalenderId)) {
      setLocalSelection(localSelection.filter((id) => id !== kalenderId));
    } else {
      setLocalSelection([...localSelection, kalenderId]);
    }
  }

  function handleConfirm() {
    setSelectedKalenderIds(localSelection);
  }

  return (
    <Drawer onOpenChange={handleOpenChange}>
      <DrawerTrigger asChild>
        <Button variant="subtle" size="icon">
          <FontAwesomeIcon icon={faCalendarStar} />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="flex flex-col">
        <DrawerHeader className="pb-0">
          <DrawerTitle className="text-sm text-center text-neutrals-900 font-semibold">
            {t('domain.termine.terminKalender')}
          </DrawerTitle>
          <DrawerDescription className="sr-only">
            {t('domain.termine.terminCalendar')}
          </DrawerDescription>
        </DrawerHeader>
        <div className="flex-1 px-4" data-vaul-no-drag>
          <Command>
            <CommandGroup>
              {kalender.map((kalenderItem) => (
                <CommandItem
                  className="transition-colors text-sm font-normal"
                  key={kalenderItem.id}
                  value={kalenderItem.name}
                  onSelect={() => handleSelect(kalenderItem.id)}>
                  <CalendarSelectCommandItemValues
                    kalenderItem={kalenderItem}
                    selectedKalenderIds={localSelection}
                  />
                </CommandItem>
              ))}
              {kalender.length > 0 && <CommandSeparator className="my-1" />}
              <CommandItem
                asChild
                className="transition-colors text-sm flex items-center gap-2 p-2 rounded-sm font-semibold">
                <Link to="/termine/kalender/uebersicht">
                  <FontAwesomeIcon
                    icon={faPlusLarge}
                    className="h-4 w-4 text-primary-blue-600"
                  />
                  <span className="text-primary-blue-600">
                    {t('domain.termine.createTerminCalendar')}
                  </span>
                </Link>
              </CommandItem>
            </CommandGroup>
          </Command>
        </div>
        <div className="p-4 shrink-0">
          <DrawerClose asChild>
            <Button className="w-full" size="lg" onClick={handleConfirm}>
              {t('domain.termine.form.fertig')}
            </Button>
          </DrawerClose>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
